export default __webpack_public_path__ + "static/media/car-cpu-2.bb4076c3.svg";